<template>
  <div>
    <div
      v-for="(soal, index) in itemDetailSoal.list_questions" 
      :key="soal.value"
      :style="(indexSoal == index && soal.list_answer[0].status == 1) ? 'border: 2px solid #000; background-color:#92fc42' :
            (indexSoal == index && soal.list_answer[0].flag == 1) ? 'border: 2px solid #000; background-color:#ffdd00;' :
            (indexSoal == index) ? 'border: 2px solid #000;' :
            (soal.list_answer[0].status == 0 && soal.list_answer[0].flag == 0 ) ? 'border: 2px solid #aaa;':
            (soal.list_answer[0].status == 1 && soal.list_answer[0].flag == 0 ) ? 'border: 2px solid #92fc42; background-color:#92fc42;':
            (soal.list_answer[0].status == 0 && soal.list_answer[0].flag == 1 ) ? 'border: 2px solid #ffdd00; background-color:#ffdd00;':
            (soal.list_answer[0].status == 1 && soal.list_answer[0].flag == 1 ) ? 'border: 2px solid #92fc42; background-color:#ffdd00;':'vs-button-dark vs-button-border'"  
      
      class="ant-btn indexSoal"
      @click="setSoal(index)"
    >
      {{ index + 1}}
    </div>
  </div>
</template>

<script>
export default {
  props: ["itemDetailSoal","indexSoal"],
  methods:{
    setSoal(value)
    {
      if(value != this.indexSoal)
      this.$emit('set-soal', value);
    }
  },
  created(){
  }
};
</script>

<style>
.indexSoal {
  width:40px !important; padding:7px !important;
  margin-right: 8px;
  height: 40px;
  margin-bottom: 12px;  
}


</style>